import React, { Component } from "react";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import {
	Row,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,InputGroup, InputGroupAddon
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx } from "../../../components/common/CustomBootstrap";
import swal from 'sweetalert';
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";
import {REST_API_END_POINT,dataEncryptKey,JQUERY_MODULE, BASE_URL, DEFAULT_JAR_TYPES} from "../../../constants/defaultValues";

var dataCrypto = new SimpleCrypto(dataEncryptKey);

class EditModal extends Component{
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.state = {	
			dependency:null,		
		};	
	}
  
	componentDidUpdate(prevProps, prevState, snapshot){   
        if(this.props.modalOpen){
			if (prevProps.dependency_id!== this.props.dependency_id && this.props.dependency_id!=0) {
				var facility_id = localStorage.getItem('facility_id');
				facility_id =  dataCrypto.decrypt(facility_id);
			
				var formData = new FormData();
				formData.append('dependency_id',this.props.dependency_id);
				formData.append('facility_id',facility_id);
				axios.post(REST_API_END_POINT+'processor/get-equipment-dependency-by-id',formData).then((res)=>{
				    var data = res.data;
					let dependency=data.equipment_dependency;
					this.setState({ 
						dependency						
					});
				}).catch(e =>{
					console.log("Addition failed , Error ", e);
				});
            }
        }
    } 

	handleSubmit(event, errors, values) {		
		if (errors.length === 0) {			
			document.getElementById("update-dependencies").disabled=true;
			
			var user_id = localStorage.getItem('user_id');
			var facility_id = localStorage.getItem('facility_id');
			facility_id =  dataCrypto.decrypt(facility_id);
			
			var formData = new FormData(document.getElementById("dependencyForm"));
			formData.append('facility_id',facility_id);
			formData.append('current_name',this.state.dependency.name);
			
			axios.post(REST_API_END_POINT+'processor/is-equipment-dependency-name-exist',formData).then((res)=>{
				var data = res.data;
				
				if(!data.status){				
					var formData = new FormData(document.getElementById("dependencyForm"));
					formData.append('dependency_id',this.props.dependency_id);
					formData.append('facility_id',facility_id);
					formData.append('user_id',user_id);

					axios.post(REST_API_END_POINT+'processor/edit-equipment-dependency',formData).then((res)=>{
						var data = res.data;
						
						var api_message=document.getElementById("api_message");
						if(data.status==1){
							api_message.innerHTML="<div class=\"rounded alert alert-success alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button><span>"+data.msg+"</span></div>";
						}else{
							api_message.innerHTML="<div class=\"rounded alert alert-danger alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button><span>"+data.msg+"</span></div>";
						}
						window.setTimeout(function() {
							JQUERY_MODULE.$(".alert").fadeTo(500, 0).slideUp(500, function(){
								JQUERY_MODULE.$(this).remove();
							});
						}, 5000);
						
						JQUERY_MODULE.$('.alert .close').on("click", function(e){
							JQUERY_MODULE.$(this).parent().fadeTo(500, 0).slideUp(500, function(){
								JQUERY_MODULE.$(this).remove();
							});
						});
						
						document.getElementById("update-dependencies").disabled=false;
						this.props.toggleModal();
						this.props.dataListRender();

					}).catch(e =>{
						console.log("Addition failed , Error ", e);
						document.getElementById("update-dependencies").disabled=false;
					});
				}else{
					swal("Equipment dependency name already exist! Please use another name");
					document.getElementById("update-dependencies").disabled=false;
				}
			}).catch(e =>{
				console.log("Addition failed , Error ", e);
				document.getElementById("update-dependencies").disabled=false;
			});

		}
	} 
	
  
	render(){
		if(this.state.dependency!=null){
			var dependency=this.state.dependency;
		}else{
			var dependency;
		}
		
	  return (	  
		<Modal
		  isOpen={this.props.modalOpen}
		  toggle={this.props.toggleModal}
		  wrapClassName="modal-right"
		  size="md"
		>
			<ModalHeader toggle={this.props.toggleModal}>
				Edit Equipment Dependency
			</ModalHeader>
			<AvForm
				id="dependencyForm"
				className="av-tooltip tooltip-right-bottom"
				onSubmit={this.handleSubmit}
			>
				<ModalBody>
					<Row>
						<Colxx lg="12">
							<AvGroup className="error-t-negative">
							  <Label>Name<span className="text-danger">*</span></Label>
							  <AvField
								id="name"
								name="name"
								type="text"
								autoComplete="off"
								value={ dependency?((dependency.name!=null)?dependency.name:''):'' }
								validate={{
								  required: {
									value: true,
									errorMessage: "This field is required."
								  },
								}}
							  />
							</AvGroup>
						</Colxx>					
					</Row>
				</ModalBody>
				<ModalFooter>
					<Button color="primary" id="update-dependencies" >
					  <IntlMessages id="customer.save" />
					</Button>
					<Button color="secondary" outline onClick={this.props.toggleModal}>
					  <IntlMessages id="customer.cancel" />
					</Button>{" "}
				</ModalFooter>
			</AvForm>
		</Modal>
	  );
  }
};

export default EditModal;
